module.exports = __webpack_public_path__ + "static/media/TEMPLATE-SKOKI+ANGRY+Golf+Bijatyka.1c2db484.jpg";